import React from "react";
import { Bar } from "react-chartjs-2";
import { configureChartFont } from "../../utils/chartFont";

const BarChart = ({ data: chartData }) => {
  configureChartFont();

  const data = {
    labels: chartData.map((l) => l.label),
    datasets: [
      {
        backgroundColor: chartData.map((l) => l.color),
        borderColor: "white",
        borderWidth: 1,
        data: chartData.map((l) => l.value),
      },
    ],
  };

  const options = {
    title: {
      display: false,
      labels: {
        family: "Google Sans",
      },
    },
    plugins: {
      legend: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    borderRadius: 10,
    categoryPercentage: 0.4,
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
